var _defs, _g, _rect, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg3PointsBasket(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 100.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #47464b;\n      }\n\n      .cls-2 {\n        fill: none;\n        stroke: #47464b;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 1.32px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M75,68.33c-4.9,0-9.51-.22-12.99-.63-5.21-.61-6.23-1.38-6.23-2.51s1.02-1.9,6.23-2.51c3.48-.41,8.09-.63,12.99-.63s9.51.22,12.99.63c5.21.61,6.23,1.38,6.23,2.51s-1.02,1.9-6.23,2.51c-3.48.4-8.09.63-12.99.63ZM59.04,65.19c2.56.56,8.21,1.11,15.96,1.11s13.4-.55,15.96-1.11c-2.56-.56-8.21-1.11-15.96-1.11s-13.4.55-15.96,1.11Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M63.88,91.99c-.06,0-.13-.01-.19-.04-.21-.09-.34-.3-.31-.53,1.95-15.6-2.78-22.62-4.9-24.92-.19-.2-.18-.52.03-.71.21-.19.53-.18.71.03.61.67,1.44,1.71,2.27,3.21l9.45,12.1,6.69-9.02c.09-.12.24-.2.39-.2.16,0,.3.06.4.19l7.87,9.61c.15.18.15.45,0,.63l-7.51,9.47c-.1.12-.25.19-.4.19-.16,0-.3-.07-.4-.19l-7.04-9.01-6.67,9c-.1.13-.25.2-.41.2ZM71.58,81.95l6.81,8.72,6.86-8.65-7.2-8.79-6.47,8.72ZM63.11,72.76c1.31,3.86,2.19,9.35,1.47,16.93l5.73-7.72-7.2-9.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M90.3,67.36c-.1.19-.14.3-.22.41-2.08,2.66-4.37,8.92-3.44,23.69.01.22-.12.43-.33.51-.06.02-.12.03-.17.03-.16,0-.31-.07-.41-.2l-13.85-18.57-7.02,8.38,7.45,9.58c.17.22.13.54-.09.71-.22.17-.54.13-.71-.09l-7.7-9.9c-.15-.19-.14-.45.01-.64l7.7-9.18c.1-.12.25-.19.4-.18.15,0,.3.08.39.2l13.22,17.74c-.38-7.83.02-17.38,3.43-22.26l1.34-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M71.9,91.99c-.11,0-.21-.03-.3-.1-.13-.1-.2-.25-.2-.4,0-.11.03-.21.1-.3l16.38-21.65c.17-.22.49-.27.71-.1.13.1.2.25.2.4,0,.11-.03.21-.1.3l-16.38,21.65c-.1.13-.25.2-.4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M71.9,72.91s-.07,0-.1-.01c-.27-.06-.45-.32-.39-.6,0-.03.67-3.4-1.14-4.56-.24-.15-.3-.46-.15-.7.15-.23.46-.3.7-.15,2.39,1.53,1.62,5.45,1.59,5.61-.05.24-.26.4-.49.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M78.03,72.91c-.24,0-.45-.17-.5-.42-.03-.18-.76-4.52,1.62-6.05.24-.15.55-.08.7.15.15.24.08.55-.15.7-1.51.97-1.36,3.95-1.17,5.02.05.27-.14.54-.41.59-.03,0-.06,0-.09,0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M73.05,68.58c-11.83,0-16.35-2.13-16.58-2.24l.89-1.82-.44.91.44-.91s1.78.83,5.94,1.43c3.85.55,10.59,1,20.87.07l.18,2.01c-4.34.4-8.09.55-11.3.55Z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 34.28,
    y: 8.01,
    width: 81.45,
    height: 55.96
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 54.64,
    y: 35.99,
    width: 40.72,
    height: 27.98
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg3PointsBasket);
export default __webpack_public_path__ + "static/media/3_points_basket.ae80a36508a85442ab6ab8395b3e8fe0.svg";
export { ForwardRef as ReactComponent };